<template>
    <div class="mx-4">
      <!-- Supplier's info -->
      <v-card>
        <v-card-title>
          Supplier's Info
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          Name: {{supplier.firstName}} {{supplier.lastName}}
          <br>
          Id: {{supplier.id}}
          <br>
          Phone: {{supplier.phoneNumber}}
          <br>
          E-mail: {{supplier.email}}
          <br>
          Type: {{supplier.type}}
        </v-card-text>
      </v-card>

      <v-card class="mt-4">
        <addProductDialog :supplierId="supplier.id" :units="units" class="pl-4 pt-4" />
        <v-divider></v-divider>
        <v-data-table :headers="headers" :items="products" :items-per-page="10" :loading="loading" class="elevation-0">
          <template v-slot:[`item.number`]="{item}">
                {{products.indexOf(item)+1}}
          </template>
          <template v-slot:[`item.image`]="{ item }">
            <v-avatar size="60px" tile class="ma-1">
              <img :src="item.imageUrl" alt>
            </v-avatar>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-row>
              <updateProductDialog :product="item" :supplierId="supplier.id" :key="item.id" :units="units" />
              <deleteProductDialog :product="item" :supplierId="supplier.id" :key="item.createdOn" />
            </v-row>
          </template>
        </v-data-table>
        <v-divider></v-divider>
      </v-card>
    </div>
</template>

<script>
import { store } from '@/store'
import { mapGetters } from 'vuex'

export default {
  props: ['id'],
  components: {
    addProductDialog: () => import('@/components/admin/product/AddProductDialog'),
    updateProductDialog: () => import('@/components/admin/product/updateProductDialog'),
    deleteProductDialog: () => import('@/components/admin/product/deleteProductDialog')
  },

  data() {
    return {
      loading: false,
      products: [],
      headers: [
        { text: 'N°', align: 'start', value: 'number' },
        { text: 'Image', value: 'image' },
        { text: 'Title', value: 'title' },
        { text: 'Category', value: 'category' },
        { text: 'Price /Kg', value: 'price' },
        { text: 'Unit', value: 'unit' },
        { text: 'District', value: 'district' },
        { text: 'Actions', value: 'actions', sortable: false }
      ]
    }
  },

  computed: {
    ...mapGetters(['user', 'error', 'units']),
    supplier() {
      return store.getters.supplier(this.id)
    }
  },

  mounted() {
    this.loading = true
    store.dispatch('getSupplierProducts', this.supplier)
      .then(data => {
        this.loading = false
        this.products = data.products
      })
      .catch(err => {
        this.loading = false
        store.commit('setError', err)
      })
  }
}
</script>
